// extracted by mini-css-extract-plugin
export var AllergenIcon = "index-module--AllergenIcon--cd643";
export var AllergensButton = "index-module--AllergensButton--87449";
export var ColumnElement = "index-module--ColumnElement--264f9";
export var Modal = "index-module--Modal--0a2d3";
export var RTL = "index-module--RTL--6ce51";
export var Wrapper = "index-module--Wrapper--6ebdc";